import { render, staticRenderFns } from "./SearchInfoBar.vue?vue&type=template&id=6bf5a3d4&scoped=true"
import script from "./SearchInfoBar.vue?vue&type=script&lang=js"
export * from "./SearchInfoBar.vue?vue&type=script&lang=js"
import style0 from "./SearchInfoBar.vue?vue&type=style&index=0&id=6bf5a3d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf5a3d4",
  null
  
)

export default component.exports